import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import configCourtsEsCL from './locales/es-CL.json';
import configCourtsEnUS from './locales/en-US.json';
import configCourtsPtBR from './locales/pt-BR.json';

export const configCourtsI18n = buildScopedI18n({
  esCL: configCourtsEsCL,
  enUS: configCourtsEnUS,
  ptBR: configCourtsPtBR,
});
